import { FC, PropsWithChildren } from 'react';
import cn from 'classnames';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { Icon } from '@/shared/uikit/Icon';

type ClosableAlertProps = {
  color?: 'white' | 'red';
  className?: string;
  onClose: () => void;
} & PropsWithChildren;

export const ClosableAlert: FC<ClosableAlertProps> = ({ children, className, color, onClose }) => {
  return (
    <Alert className={cn(color, className)}>
      <IconStyled className={cn(color)} name="warning-circle" size="s20" />
      <span>{children}</span>
      <IconClick name="x" size="s20" onClick={onClose} />
    </Alert>
  );
};

const Alert = styled.div`
  border-radius: 8px;
  background: ${COLORS.systemLight200};
  padding: 12px;
  display: flex;
  gap: 12px;
  align-items: flex-start;
  font-size: 14px;
  width: fit-content;

  &.red {
    background: ${COLORS.systemFlame100};
  }
`;

const IconStyled = styled(Icon)`
  &.red {
    color: ${COLORS.systemFlame200};
  }
`;

const IconClick = styled(Icon)`
  cursor: pointer;
`;
